import * as server from "@/utils/http"

export const _page = params => server.get("/classes/page", params);
export const _get = params => server.get("/classes/get", params);
export const _upload = params => server.postfrom("/classes/upload", params);
export const _template=params=>server.download('/classes/template',params);
export const _updateStatus = params => server.get("/classes/updateStatus", params);
export const _save = params => server.post(params.id ? "/classes/update" : "/classes/save", params);

